import React, { useState, useEffect } from 'react';
import { Info, CheckCircle, AlertTriangle } from 'lucide-react';

export const GlobalAlertModal = () => {
    const [alertData, setAlertData] = useState<{ message: string, type: 'info' | 'success' | 'error' } | null>(null);

    useEffect(() => {
        // Guardar alerta original
        const originalAlert = window.alert;

        // Sobrescribir globalmente
        window.alert = (message: any) => {
            let msg = String(message);
            let type: 'info' | 'success' | 'error' = 'info';
            
            // Inferencia básica de diseño según el string enviado a la alerta
            const lowerMsg = msg.toLowerCase();
            if (lowerMsg.includes('éxito') || lowerMsg.includes('exitos') || lowerMsg.includes('registrad') || lowerMsg.includes('actualizad') || lowerMsg.includes('agregad') || lowerMsg.includes('guardad')) {
                type = 'success';
            } else if (lowerMsg.includes('error') || lowerMsg.includes('fall') || lowerMsg.includes('inválido') || lowerMsg.includes('invalid') || lowerMsg.includes('obligatorio') || lowerMsg.includes('completa')) {
                type = 'error';
            }

            setAlertData({ message: msg, type });
        };

        return () => {
            window.alert = originalAlert; // Restaurar al desmontar (por si acaso)
        };
    }, []);

    if (!alertData) return null;

    const isSuccess = alertData.type === 'success';
    const isError = alertData.type === 'error';

    return (
        <div className="fixed inset-0 z-[999999] flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm animate-in fade-in duration-200">
            <div className={`bg-white rounded-[2.5rem] shadow-2xl max-w-sm w-full border-t-[12px] overflow-hidden animate-in zoom-in-95 duration-200 ${isSuccess ? 'border-emerald-500' : isError ? 'border-rose-500' : 'border-blue-500'}`}>
                <div className={`px-6 py-8 flex flex-col items-center text-center border-b ${isSuccess ? 'bg-emerald-50/50 border-emerald-100 text-emerald-600' : isError ? 'bg-rose-50/50 border-rose-100 text-rose-600' : 'bg-blue-50/50 border-blue-100 text-blue-600'}`}>
                    <div className={`w-20 h-20 rounded-[1.5rem] flex items-center justify-center mb-4 shadow-sm border-4 border-white ${isSuccess ? 'bg-emerald-100' : isError ? 'bg-rose-100' : 'bg-blue-100'}`}>
                        {isSuccess ? <CheckCircle size={40} className="text-emerald-500" strokeWidth={2.5} /> : isError ? <AlertTriangle size={40} className="text-rose-500" strokeWidth={2.5} /> : <Info size={40} className="text-blue-500" strokeWidth={2.5} />}
                    </div>
                    <h2 className="text-2xl font-black uppercase italic tracking-tighter">
                        {isSuccess ? '¡Excelente!' : isError ? 'Atención' : 'Información'}
                    </h2>
                </div>
                <div className="p-8 text-center space-y-6">
                    <p className="text-slate-600 font-bold text-[15px] leading-relaxed break-words">{alertData.message}</p>

                    <button 
                        onClick={() => setAlertData(null)} 
                        className={`w-full text-white py-4 rounded-2xl font-black uppercase shadow-xl transition-all active:scale-95 italic tracking-widest ${isSuccess ? 'bg-emerald-500 hover:bg-emerald-600 shadow-emerald-500/30' : isError ? 'bg-rose-500 hover:bg-rose-600 shadow-rose-500/30' : 'bg-blue-500 hover:bg-blue-600 shadow-blue-500/30'}`}
                        autoFocus
                    >
                        Entendido
                    </button>
                </div>
            </div>
        </div>
    );
};
